import React, { useState, useEffect, useContext } from "react";
import { NavHashLink as NavLink } from "react-router-hash-link";
import { Link as SmoothLink } from "react-scroll";
 import { Link, withRouter } from "react-router-dom";
import { Debounce } from '../../../utils/Debounce';
import UseMousePosition from '../../../utils/UseMousePosition';
import NousConnaitre from '../../../views/NousConnaitre';
import NavActions from "../NavActions";
import SubNav from "../SubNav";
// import Logo from "../../elements/Logo";
import ImgBurger from "../../../assets/img/bt_burger.svg";
import ImgBurgerClose from "../../../assets/img/bt_burger_close.svg";
import Icon from "../../../assets/img/logo.svg";
import datas from "../../../datas/rubriques.json";

const _component = {
    NousConnaitre: NousConnaitre
};

const MenuItems = () => {
        // const { page, updatePage } = useContext(PageContext);
        const isActive = (path) => {
            return location.pathname.includes(path) ? 'active' : '';
        }

        const itemArray = [];
        datas.map((item, index) => {
          const { title, slug, component, subRubriques, url, isMobileOnly } = item;
          const Component = component ? _component[component] : null;
          let link = "";
          if (subRubriques.length > 0) {
              link = slug === "" ? "home" : subRubriques[0].slug;
          } else if (typeof url !== undefined) {
              link = url;
          } else {
              link = slug;
          }

          // Rubriques
          itemArray.push(
            <li key={slug} className = { `nav-item ${slug} ${
                    isMobileOnly ? "is-hidden-desktop" : ''
                } ${isActive(`/${slug}`)}`}
            >
              {
                component ?
                  <Component />
                  :

                    slug === 'bilan_financier' ?
                    <a className="nav-link" href={url} target="_blank"><span>{title}</span></a>
                    :
                    <NavLink className="nav-link" to={`/${slug}/#${link}`} >
                      <span>{title}</span>
                    </NavLink>
              }
              <ul className="subnav">
              {
                subRubriques && subRubriques.map(item2 =>
                  <li className={`nav-item`} >
                    {
                    slug && isActive(`/${slug}`)
                    ?
                    <SmoothLink
                            key={`${item2.slug}`}
                            activeClass="active"
                            to={`${item2.slug}`}
                            spy
                            smooth
                            hashSpy
                            offset={0}
                            duration={700}
                            className={`nav-link subnav__${ item2.slug } `}
                        >
                            {item2.title}
                        </SmoothLink>
                    :
                      <NavLink className="nav-link" to={`/${slug}/#${item2.slug}`} >
                        {item2.title}
                      </NavLink>

                    }
                  </li>
                )
              }
              </ul>
          </li>
        );
    });
    return itemArray;
};
const Nav = ({ location}) => {
    // const { page, updatePage } = useContext(PageContext);
    const [isMenuOpen, setIsMenuOpen] = useState(false);
    const [prevScrollPos, setPrevScrollPos] = useState(0);
    const [visible, setVisible] = useState(true);
    const { y } = UseMousePosition();

    const handleScroll = Debounce(() => {
        const currentScrollPos = window.pageYOffset;
        setVisible((prevScrollPos > currentScrollPos && prevScrollPos - currentScrollPos > 70)  || currentScrollPos < 10);
        setPrevScrollPos(currentScrollPos);
    }, 100);

    useEffect(() => {
        window.addEventListener('scroll', handleScroll);
        !visible && y && setVisible(y < 100);
        return () => window.removeEventListener('scroll', handleScroll);
    }, [prevScrollPos, visible, handleScroll]);

    const navbarStyles = {
        textAlign: 'center',
        transition: 'top 0.6s'
    }

    const handleClick = () => {
        setIsMenuOpen(!isMenuOpen);
    };

    return (
        <>
            <aside
                id="nav"
                className={isMenuOpen ? "active d-flex flex-column" : ""}
                style={{ ...navbarStyles, top: visible ? '0' : '-200px' }}
            >
                <div id="nav__container">
                    <div id="logo-container" className="">
                        <Link to="/"
                            className={`navbar-brand`}
                        >
                            <img src={Icon}  alt="ES" width="74px" height="85px" />
                        </Link>
                    </div>
                    <div
                        id="nav__burger"
                        className="is-hidden-widescreen"
                        onClick={() => {
                            handleClick();
                        }}
                    >
                        <img src={isMenuOpen ? ImgBurgerClose : ImgBurger} />
                    </div>
                    <ul
                        className={`nav`}
                        onClick={() => {
                            handleClick();
                        }}
                    >
                        <MenuItems />
                    </ul>
                </div>
								<NavActions />
            </aside>

           {
					location && (location.pathname === '/nos_performances/' || location.pathname === '/nos_actions_rse/') ? <SubNav /> : ''
          // location && (location.pathname === '/nos_performances/' ) ? <SubNav /> : ''
        }

        </>
    );
};
export default withRouter(Nav);
